<script>
    import { onMount } from 'svelte';
    import * as Icons from 'lucide-svelte';
    import LyP from '../../../layouts/components/LyP.svelte';
    import LyUser from '../../../layouts/users/LyUser.svelte';
    import { AiAnnouncementStore } from './AiAnnouncementStore.svelte.js';
    import LyContent from '../../../layouts/components/LyContent.svelte';
    import LyTable from '../../../layouts/tables/LyTable.svelte';
    import LyTableHead from '../../../layouts/tables/LyTableHead.svelte';
    import LyTableHeadRow from '../../../layouts/tables/LyTableHeadRow.svelte';
    import LyTableHeadCol from '../../../layouts/tables/LyTableHeadCol.svelte';
    import LyTableBody from '../../../layouts/tables/LyTableBody.svelte';
    import LyTableBodyRow from '../../../layouts/tables/LyTableBodyRow.svelte';
    import LyTableBodyCol from '../../../layouts/tables/LyTableBodyCol.svelte';
    import LyId from '../../../layouts/components/LyId.svelte';
    import { ValueService } from '../../../services/ValueService.js';

    /**
     * @type {{
     *     withUser?: boolean | string,
     * }}
     */
    let { withUser = true } = $props();

    let mounting = $state(true);
    const showWithUser = $derived(ValueService.toBool(withUser));

    onMount(() => {
        AiAnnouncementStore.reset();
        mounting = false;
    });
</script>

{#if mounting && AiAnnouncementStore.isLoading}
    <LyContent>
        <LyP><em>Daten werden geladen&hellip;</em></LyP>
    </LyContent>
{:else if AiAnnouncementStore.list.length === 0}
    <LyContent>
        <LyP><em>Keine Daten gefunden&hellip;</em></LyP>
    </LyContent>
{:else}
    <LyTable>
        <LyTableHead>
            <LyTableHeadRow>
                <LyTableHeadCol>ID</LyTableHeadCol>
                {#if showWithUser}
                    <LyTableHeadCol>Benutzer</LyTableHeadCol>
                {/if}
                <LyTableHeadCol>
                    <div>Anbieter</div>
                    <div><strong>System</strong></div>
                </LyTableHeadCol>
                <LyTableHeadCol>Bereich</LyTableHeadCol>
                <LyTableHeadCol>High-Risk</LyTableHeadCol>
            </LyTableHeadRow>
        </LyTableHead>
        <LyTableBody>
            {#each AiAnnouncementStore.list as row}
                <LyTableBodyRow>
                    <LyTableBodyCol>
                        <LyId show_id={row.ai_announcement_id} />
                    </LyTableBodyCol>
                    {#if showWithUser}
                        <LyTableBodyCol>
                            <LyUser user_id={row.user_id} />
                        </LyTableBodyCol>
                    {/if}
                    <LyTableBodyCol>
                        <div class="text-sm">{row.company || '-'}</div>
                        <div><strong>{row.system || '-'}</strong></div>
                    </LyTableBodyCol>
                    <LyTableBodyCol>
                        {row.used_for || '-'}
                    </LyTableBodyCol>
                    <LyTableBodyCol>
                        {#if row.risk === 'prohibited'}
                            <Icons.OctagonX class="text-error-500" />
                        {:else if row.risk === 'high-risk'}
                            <Icons.TriangleAlert class="text-warning-500" />
                        {:else if row.risk === ''}
                            <Icons.ShieldQuestionMark class="text-unknown-500" />
                        {/if}
                    </LyTableBodyCol>
                </LyTableBodyRow>
            {/each}
        </LyTableBody>
    </LyTable>
{/if}
